// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkbox-input_wrapper__TEx4G","filled":"checkbox-input_filled__M_rPW","partial":"checkbox-input_partial__2EMMJ"};